class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const target = new Date(this.dataset.target).getTime();

    if (Number.isNaN(target)) {
      this.hidden = true;
      return;
    }

    this.target = target;
    this.unitsEl = this.querySelector('[data-countdown-units]');
    this.expiredEl = this.querySelector('[data-countdown-expired]');
    this.daysEl = this.querySelector('[data-days]');
    this.hoursEl = this.querySelector('[data-hours]');
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const distance = this.target - Date.now();

    if (distance <= 0) {
      clearInterval(this.interval);
      if (this.unitsEl) this.unitsEl.hidden = true;
      if (this.expiredEl) this.expiredEl.hidden = false;
      this.dispatchEvent(new CustomEvent('countdown:complete', { bubbles: true }));
      return;
    }

    const days = Math.floor(distance / 86400000);
    const hours = Math.floor((distance % 86400000) / 3600000);
    const minutes = Math.floor((distance % 3600000) / 60000);
    const seconds = Math.floor((distance % 60000) / 1000);

    if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
  }
}

customElements.define('countdown-timer', CountdownTimer);
